export var DataUtils;
(function (DataUtils) {
    function cloneObj(obj) {
        let newObj = {};
        for (let key in obj) {
            newObj[key] = obj[key];
        }
        return newObj;
    }
    DataUtils.cloneObj = cloneObj;
    function isNone(value) {
        return typeof value === 'undefined' || value === null;
    }
    DataUtils.isNone = isNone;
    function isNotNone(value) {
        return typeof value !== 'undefined' && value !== null;
    }
    DataUtils.isNotNone = isNotNone;
    function getNonNone(...values) {
        for (let i = 0; i < values.length; i++) {
            if (!this.isNone(values[i])) {
                return values[i];
            }
        }
        return null;
    }
    DataUtils.getNonNone = getNonNone;
    function clearAllData() {
        try {
            localStorage.clear();
        }
        catch (e) {
            logger.warn(e.stack);
        }
    }
    DataUtils.clearAllData = clearAllData;
    function assignDeep(target, ...overrideTarget) {
        const args = Array.prototype.slice.call(arguments);
        const startIndex = 1;
        const output = Object(target || {});
        for (let a = startIndex, alen = args.length; a < alen; a++) {
            const from = args[a];
            const keys = Object.keys(Object(from));
            for (let k = 0; k < keys.length; k++) {
                const key = keys[k];
                if (isArray(output[key]) || isArray(from[key])) {
                    const f = (isArray(from[key]) ? from[key].slice() : []);
                    output[key] = f;
                }
                if (isFunction(output[key]) || isFunction(from[key])) {
                    output[key] = from[key];
                }
                else if (isObject(output[key]) || isObject(from[key])) {
                    output[key] = assignDeep(output[key], from[key]);
                }
                else {
                    output[key] = from[key];
                }
            }
        }
        return output;
    }
    DataUtils.assignDeep = assignDeep;
    function isFunction(obj) {
        if (typeof /./ != 'function' && typeof Int8Array != 'object') {
            return typeof obj == 'function' || false;
        }
        return isCheck(obj, 'Function');
    }
    DataUtils.isFunction = isFunction;
    function isArray(obj) {
        return Array.isArray(obj);
    }
    DataUtils.isArray = isArray;
    function isObject(obj) {
        const type = typeof obj;
        return type === 'function' || type === 'object' && !!obj;
    }
    DataUtils.isObject = isObject;
    function isCheck(obj, type) {
        return toString.call(obj) === '[object ' + type + ']';
    }
    class LocalStorageItem {
        constructor(key, defaultData = null, clearLocalData = false) {
            this._key = key;
            try {
                if (clearLocalData) {
                    this.clearData();
                }
                const value = localStorage.getItem(this._key);
                this._data = value ? JSON.parse(value) : null;
            }
            catch (e) {
                try {
                    const value = localStorage.getItem(this._key);
                    this._data = String(value);
                    console.log(this._data);
                }
                catch (e) {
                    this._data = null;
                }
            }
            if (DataUtils.isNotNone(defaultData) && DataUtils.isNotNone(this._data)) {
                if (DataUtils.isObject(this._data)) {
                    this._data = DataUtils.assignDeep(defaultData, this._data);
                }
            }
            else if (defaultData) {
                this._data = defaultData;
            }
            window.addEventListener("beforeunload", () => {
                this.saveData();
            });
        }
        get key() {
            return this._key;
        }
        get data() {
            return this._data;
        }
        set data(data) {
            if (data === null) {
                this.clearData();
            }
            else {
                this._data = data;
            }
        }
        clearData() {
            this._data = null;
            localStorage.removeItem(this._key);
        }
        saveData() {
            let rawData;
            if (DataUtils.isObject(this._data)) {
                rawData = JSON.stringify(this._data);
            }
            else {
                rawData = String(this._data);
            }
            localStorage.setItem(this._key, rawData);
        }
    }
    DataUtils.LocalStorageItem = LocalStorageItem;
    function getLocalStorageItem(key, defaultData = null, clearLocalData = false) {
        return new LocalStorageItem(key, defaultData, clearLocalData);
    }
    DataUtils.getLocalStorageItem = getLocalStorageItem;
    function setCookie(name, value, days = 9999) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
    DataUtils.setCookie = setCookie;
    function getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ')
                c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0)
                return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
    DataUtils.getCookie = getCookie;
    function removeCookie(name) {
        document.cookie = name + '=; Max-Age=-99999999;';
    }
    DataUtils.removeCookie = removeCookie;
    function parseNumber(value, defaultValue = 0, optional = false) {
        return parseObject(Number(value) || defaultValue, defaultValue, optional);
    }
    DataUtils.parseNumber = parseNumber;
    function parseString(value, defaultValue = '', optional = false) {
        return parseObject(String(value), defaultValue, optional);
    }
    DataUtils.parseString = parseString;
    function imageLookup(data, size) {
        let imageFound = null;
        if (data) {
            if (data instanceof Array) {
                data.some((image) => {
                    imageFound = image;
                    if (image.size === size) {
                        return true;
                    }
                    else {
                        return false;
                    }
                });
                if (!imageFound) {
                    logger.dir(data);
                    logger.warn('Cant find image ' + size);
                    imageFound = data[0];
                }
            }
            else {
                imageFound = data;
            }
            return imageFound;
        }
        return null;
    }
    DataUtils.imageLookup = imageLookup;
    function parseArray(value, defaultValue = [], optional = false) {
        const obj = parseObject(value, defaultValue, optional);
        if (obj['length'] > -1) {
            return obj;
        }
        return defaultValue;
    }
    DataUtils.parseArray = parseArray;
    function parseBoolean(value, defaultValue = false) {
        if (typeof value === 'string') {
            switch (String(value).toLowerCase()) {
                case 'false':
                case 'null':
                case 'undefined':
                case 'none':
                case 'nee':
                case 'no':
                case '0':
                case '':
                    return false;
                default:
                    return true;
            }
        }
        else {
            return parseObject(Boolean(value), defaultValue);
        }
    }
    DataUtils.parseBoolean = parseBoolean;
    function parseObject(value, defaultValue = null, optional = false) {
        if ((typeof value === 'undefined' || value === null) && !optional) {
            logger.error('prop error ' + value);
            return defaultValue;
        }
        return value;
    }
    DataUtils.parseObject = parseObject;
})(DataUtils || (DataUtils = {}));
